import { defineComponent as p, openBlock as o, createElementBlock as a, mergeProps as u, unref as e, renderSlot as i, createElementVNode as l, createCommentVNode as g } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, M = { key: 1 }, f = { key: 2 }, A = { key: 3 }, k = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconEquals"
}, V = /* @__PURE__ */ p({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const r = s, { bind: H, weight: n } = m(r);
    return (d, t) => (o(), a("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(H)), [
      i(d.$slots, "default"),
      e(n) === "bold" ? (o(), a("g", Z, t[0] || (t[0] = [
        l("path", { d: "M228,160a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,160ZM40,108H216a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (o(), a("g", M, t[1] || (t[1] = [
        l("path", {
          d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M224,160a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,160ZM40,104H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" }, null, -1)
      ]))) : e(n) === "fill" ? (o(), a("g", f, t[2] || (t[2] = [
        l("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM184,160H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Zm0-48H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : e(n) === "light" ? (o(), a("g", A, t[3] || (t[3] = [
        l("path", { d: "M222,160a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,160ZM40,102H216a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12Z" }, null, -1)
      ]))) : e(n) === "regular" ? (o(), a("g", k, t[4] || (t[4] = [
        l("path", { d: "M224,160a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,160ZM40,104H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" }, null, -1)
      ]))) : e(n) === "thin" ? (o(), a("g", h, t[5] || (t[5] = [
        l("path", { d: "M220,160a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,160ZM40,100H216a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  V as default
};
